import React, { useState, useEffect } from "react";
import queryString from "query-string";

// seo
import Seo from "../components/Seo";

// services
import { Mixpanel, MixpanelEvents } from "../services/Mixpanel";

//image
import bannerImg from "../images/aboutUs/about-banner.png";

// components
import Banner from "../components/Banner";
import OurStory from "../components/AboutUs/OurStory";
import ExecutiveTeamNew from "../components/AboutUs/ExecutiveTeamNew";
import BoardOfDirectors from "../components/AboutUs/BoardOfDirectors";
import IndianLeadershipTeamNew from "../components/AboutUs/IndianLeadershipTeamNew";
import MedicalAdvisoryBoardNew from "../components/AboutUs/MedicalAdvisoryBoardNew";
import SeniorAdvisoryBoardNew from "../components/AboutUs/SeniorAdvisoryBoardNew";
import Investors from "../components/AboutUs/Investors";
import JoinTwin from "../components/AboutUs/JoinTwin";

const AboutUsPage = props => {
  const [depth25, setDepth25] = useState(true);
  const [depth50, setDepth50] = useState(true);
  const [depth75, setDepth75] = useState(true);
  const [depth100, setDepth100] = useState(true);
  const [deviceType, setDeviceType] = useState(""); // To store the device type

  useEffect(() => {
    let loadTime =
      window.performance.timing.domContentLoadedEventEnd -
        window.performance.timing.navigationStart || 700;

    let utmParams = queryString.parse(props.location.search);

    // Mixpanel Event
    Mixpanel.track(MixpanelEvents.page_viewed, {
      page_name: "About Us Page",
      asset: "India Website",
      asset_name: "India Corporate Website",
      load_time: loadTime,
      campaign_id: utmParams.campaignid,
      device_type: deviceType,
    });
  }, [props.location.search, deviceType]);

  useEffect(() => {
    const handleScroll = () => {
      const pageYOffset = window.pageYOffset;
      const height = document.body.scrollHeight - window.innerHeight;
      const progress = Math.round((pageYOffset / height) * 100);

      if (progress === 25 && depth25) {
        Mixpanel.track(MixpanelEvents.page_depth_viewed, {
          page_name: "About Us Page",
          asset: "India Website",
          asset_name: "India Corporate Website",
          page_depth: progress,
        });
        setDepth25(false);
      } else if (progress === 50 && depth50) {
        Mixpanel.track(MixpanelEvents.page_depth_viewed, {
          page_name: "About Us Page",
          asset: "India Website",
          asset_name: "India Corporate Website",
          page_depth: progress,
        });
        setDepth50(false);
      } else if (progress === 75 && depth75) {
        Mixpanel.track(MixpanelEvents.page_depth_viewed, {
          page_name: "About Us Page",
          asset: "India Website",
          asset_name: "India Corporate Website",
          page_depth: progress,
        });
        setDepth75(false);
      } else if (progress === 100 && depth100) {
        Mixpanel.track(MixpanelEvents.page_depth_viewed, {
          page_name: "About Us Page",
          asset: "India Website",
          asset_name: "India Corporate Website",
          page_depth: progress,
        });
        setDepth100(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [depth25, depth50, depth75, depth100]);

  // Find The Device Type Of The User
  useEffect(() => {
    // Function to update device type based on screen width
    const updateDeviceType = () => {
      const width = window.innerWidth;
      if (width <= 768) {
        setDeviceType("Mobile");
      } else if (width <= 1024) {
        setDeviceType("Tablet");
      } else {
        setDeviceType("Desktop");
      }
    };

    // Update device type when the component mounts
    updateDeviceType();

    // Add an event listener to update device type when the window is resized
    window.addEventListener("resize", updateDeviceType);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", updateDeviceType);
    };
  }, []);

  // To Track Mixpanel Event When User Leave Page
  useEffect(() => {
    const handlePageExit = event => {
      Mixpanel.track(MixpanelEvents.page_exit, {
        page_name: "About Us Page",
        asset: "India Website",
        asset_name: "India Corporate Website",
      });
    };

    window.addEventListener("beforeunload", handlePageExit);

    return () => {
      window.removeEventListener("beforeunload", handlePageExit);
    };
  }, []);

  // Mixpanel Events -> Cta Click events
  const handleMixpanelCTA = (ctaText, ctaLocation) => {
    Mixpanel.track(MixpanelEvents.contact_button_clicked, {
      page_name: "About Us Page",
      asset: "India Website",
      asset_name: "India Corporate Website",
      cta_text: ctaText,
      cta_location: ctaLocation,
    });
  };

  return (
    <>
      <Seo
        title="Our Life's Work | The Team Behind Twin Health India"
        description="We combine first-of-its-kind AI with human care to help people with diabetes and metabolic conditions lead happier, healthier lives. "
      />
      <Banner
        title="Our Life's Work"
        description="We combine first-of-its-kind technology with human care to help people with diabetes and other chronic metabolic conditions lead happier, healthier lives."
        bannerImage={bannerImg}
        imageHeight="650px"
        imageWidth="462px"
      />
      <OurStory />
      <ExecutiveTeamNew />
      <BoardOfDirectors />
      <MedicalAdvisoryBoardNew />
      <SeniorAdvisoryBoardNew />
      <IndianLeadershipTeamNew />
      <Investors />
      <JoinTwin onCtaClick={handleMixpanelCTA} />
    </>
  );
};

export default AboutUsPage;
